import { UserEditor } from 'components';
import { DEFAULT_USER_DATA } from 'components/UserEditor/UserEditor';
import React, { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getUserProfileInfo } from 'services/user/user.service';

export default function ViewUser() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [formData, setFormData] = useState();

  useEffect(() => {
    if (!params.get('userid')) navigate('/system/createuser?tab=users');

    getUserProfileInfo(params.get('userid'))
      .then((res) => {
        if (res.status === 200) {
          const data = res.data.result;
          const { street, city, state, zipcode } = JSON.parse(
            data?.address || '{"street":"","city":"","state":"","zipcode":""}',
          );
          const { name, phone } = JSON.parse(data?.emergencyContact || '{"name":"","phone":""}');

          const userObject = {
            roles: JSON.parse(data?.roles || '[]'),
            base: data?.homebase || '',
            department: data?.department || '',
            rank: data?.rank || '',
            maintenance: data?.maintenanceOperatorLevel || 0,
            name: data?.name || '',
            email: data?.email || '',
            employeeId: data?.employeeId || '',
            phone: data?.phoneNumber || '',
            gender: data?.gender || 'Not Specified',
            birthday: data?.dob || null,
            address: street || '',
            city: city || '',
            state: state || '',
            zipcode: zipcode || '',
            eContactName: name || '',
            eContactPhone: phone || '',
          };

          setFormData(userObject);
        }
      })
      .catch((err) => {
        console.error('Error from getUserProfileInfo:', err);
      });
  }, []);

  const onBack = () => navigate(-1);

  return (
    <div className="d-flex flex-column w-100 h-100 justify-content-between user-select-none">
      <UserEditor
        value={formData}
        onChange={setFormData}
        disabledFields={[...Object.keys(DEFAULT_USER_DATA)]} //disable all fields
      />
      {/* Back Button */}
      <Container fluid className="d-flex w-100 justify-content-between align-items-center">
        <Button variant="dark" className="p-3 px-4 w-100 my-3 w-md-auto" onClick={onBack}>
          Back
        </Button>
      </Container>
    </div>
  );
}
